import { StepOption } from "../types/wizard";

type ProductTypeKey =
  | 'ChenillePatches'
  | 'EmbrPatches'
  | 'Flexbroidery'
  | 'FlexStyle'
  | 'LeatherPatches'
  | 'FlexStyleHolographic'
  | 'PVCEmblems'
  | 'WovenPatches'
  | '3DEmbrPatches';

interface ProductTypeMapping {
  code: string | null;
  name: string;
}

type ProductTypeMappingRecord = Record<ProductTypeKey, ProductTypeMapping>;

function mapProductType(
  productType: string | null,
  data: readonly StepOption[] | undefined
): StepOption | null {
  const typeMapping: ProductTypeMappingRecord = {
    'ChenillePatches': { code: 'CHE', name: 'Chenille Emblems' },
    'EmbrPatches': { code: 'EM', name: 'Embroidered & Print Stitch Patches' },
    'Flexbroidery': { code: null, name: 'Flexbroidery' },
    'FlexStyle': { code: 'FS', name: 'FlexStyle' },
    'LeatherPatches': { code: 'LE', name: 'Leather Emblems' },
    'FlexStyleHolographic': { code: 'FS', name: 'FlexStyle Holographic Emblems' },
    'PVCEmblems': { code: null, name: 'PV+' },
    'WovenPatches': { code: 'WOV', name: 'Woven' },
    '3DEmbrPatches': { code: 'EM', name: '3D Embroidered Patches' }
  };

  const isValidProductType = (type: string): type is ProductTypeKey => {
    return type in typeMapping;
  };

  if (!productType || !isValidProductType(productType)) {
    return null;
  }

  const target = typeMapping[productType];

  const normalizeString = (str: string | undefined): string =>
    str?.toLowerCase().trim() ?? '';

  if (target.code) {
    const matchByCode = data?.find((item) => item.code === target.code);
    if (matchByCode) {
      return matchByCode;
    }
  }

  const matchByName = data?.find((item) =>
    normalizeString(item.name) === normalizeString(target.name)
  );

  return matchByName ?? null;
}

export default mapProductType;